import { gql } from "@apollo/client";

export const DELETE_COMMENT = gql`
  mutation deleteComment($comment_id: String!) {
    ListingComments {
      deleteComment(comment_id: $comment_id) {
        comment_id
        listing_id
        commenter_name
        commenter_img
        created_by
        comment
        created_at
        answer
        answered_at
        answered_by
        answered_by_name
        answered_by_img
        deleted_at
      }
    }
  }
`;

export const ADD_COMMENT = gql`
  mutation addComment($comment: String!, $listing_id: Int!) {
    ListingComments {
      addComment(comment: $comment, listing_id: $listing_id) {
        comment_id
        listing_id
        commenter_name
        commenter_img
        created_by
        comment
        created_at
        answer
        answered_at
        answered_by
        answered_by_name
        answered_by_img
        deleted_at
      }
    }
  }
`;

export const ADD_ANSWER = gql`
  mutation addAnswer($comment_id: String!, $answer: String!) {
    ListingComments {
      addAnswer(comment_id: $comment_id, answer: $answer) {
        comment_id
        listing_id
        commenter_name
        commenter_img
        created_by
        comment
        created_at
        answer
        answered_at
        answered_by
        answered_by_name
        answered_by_img
        deleted_at
      }
    }
  }
`;

export const HIDE_COMMENT = gql`
  mutation hideComment($comment_id: String!) {
    ListingComments {
      hideComment(comment_id: $comment_id)
    }
  }
`;

export const UPDATE_COMMENTS_ENABLED = gql`
  mutation updateCommentsEnabled($listing_id: Int!, $enabled: Boolean!) {
    Listing {
      update(id: $listing_id, data: { comments_enabled: $enabled }) {
        id
      }
    }
  }
`;
